import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  inputLabel: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontFamily: 'Inter, sans-serif',
    fontSize: '1rem',
    transition: 'color 0.2s ease'
  },
  inputLabelFocused: {
    color: theme.palette.blue_300.main // Cor azul quando focado
  },
  inputField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',

      '&.Mui-focused fieldset': {
        borderColor: theme.palette.blue_300.main,
        borderWidth: '2px'
      },

      // Hover state (opcional)
      '&:hover fieldset': {
        borderColor: theme.palette.blue_300.main
      }
    },
    '& input': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      padding: '12px'
    },
    '& textarea': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main
    },
    '& .MuiOutlinedInput-multiline': {
      padding: '12px 14px'
    }
  }
}))
